export const TECHNICIAN_LABEL = "Technician";
export const TECHNICIAN_NAME = "Technician Name";
export const ADD_TECHNICIAN_LABEL = "Add Technician";
export const EDIT_TECHNICIAN_LABEL = "Edit Technician";
export const TECHNICIAN_ID_LABEL = "Technician Id";
export const NEW_TECHNICIAN_LABEL = "New Technician";
export const EXPERTISE_LABEL = "Expertise";
export const TECHNICIAN_EXPERTISE = "Technician Expertise";
export const TECHNICIAN_DRAFT_ID = "technician_draft_id";
export const TECHNICIAN_NAME_ACCESS_KEY = "technician_name";
